// extracted by mini-css-extract-plugin
export default {"base":"vp_VZGLf","items":"vp_fc3Ir","item":"vp_a6dXe","passed":"vp_aK5WV","current":"vp_mEXMH","hidden":"vp__zJqW"};